import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type LocationOverviewHrisNotificationsController from 'garaje/pods/location-overview/hris-dashboard/notifications/controller';
import type { NotificationsModel } from 'garaje/pods/location-overview/hris-dashboard/notifications/controller';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type StateService from 'garaje/services/state';

export default class HrisDashboardNotificationsRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;
  @service declare state: StateService;

  controllerName = 'location-overview/hris-dashboard/notifications';
  templateName = 'location-overview/hris-dashboard/notifications';

  async model(): Promise<NotificationsModel> {
    return this.ajaxFetch.request(`/api/v1/hris/notifications?company_id=${this.state.currentCompany.id}`);
  }

  // This route reuses the location-overview controller (controllerName above) but,
  // unlike that route, must call setupFromModel() itself — otherwise the fetched
  // settings are ignored and the company-wide tab renders DEFAULT_STATE.
  setupController(
    controller: LocationOverviewHrisNotificationsController,
    model: NotificationsModel,
    transition: Transition<unknown>,
  ): void {
    super.setupController(controller, model, transition);
    controller.setupFromModel();
  }
}
